import { ReactElement } from 'react';
import { Form } from 'react-bootstrap';
import { Status } from '../../enums';

export const CodingFormTitle = ({ status }: any): ReactElement => {
  switch (status) {
    case Status.Supervisor:
      return (
        <Form.Text>
          Verian Coders are uncertain about the offence code and/or cyber flag.
          <br />
          For each affected form, please select an offence code and the appropriate cyber flag, and indicate whether or not you are certain
          of these values.
          <p />
          When you have finished editing, click the &#39;Save&#39; button.
          <br />
          To view details of the offence, click the &#39;Open Form&#39; button to view the victim form in full.
        </Form.Text>
      );
    case Status.Review:
      return (
        <Form.Text>
          Verian and the ONS disagree about the code and/or cyber flag for one or more of these victim forms.
          <br />
          If you are happy to accept the ONS&#39;s coding, select the &#39;V. Accept&#39; (Verian Accept) option &#39;Yes&#39;: otherwise select the
          &#39;V. Accept&#39; option &#39;No&#39;.
          <br />
          Please add a comment if you reject the ONS&#39;s coding, and it will be referred to the Verian exec team for further review.
          <p />
          When you have finished editing, click the &#39;Save&#39; button.
          <br />
          To view details of the offence, click the &#39;Open Form&#39; button to view the victim form in full.
        </Form.Text>
      );

    case Status.ExecReview:
      return (
        <Form.Text>
          Verian coders have rejected the ONS&#39;s code and/or cyber flag for one or more of these victim forms.
          <br />
          Please select the final code and cyber flag for each of the rejected victim forms, or click the box to push the record back to the ONS for
          review.
          <br />
          Please add a comment, regardless of what you do.
          <p />
          When you have finished editing, click the &#39;Save&#39; button.
          <br />
          To view details of the offence, click the &#39;Open Form&#39; button to view the victim form in full.
        </Form.Text>
      );
    case Status.ONSCoding:
      return (
        <Form.Text>
          Select a code and/or cyber flag for each victim form that has status ONS Coding.  Other forms may be coded if desired, but this is not mandatory.
          <br />
          Setting a code AND cyber flag is mandatory if the victim form requires a quality check or has a referral code.
          <br />
          Otherwise, setting a code is only mandatory if Verian are uncertain of the code and setting a cyber flag is only mandatory if Verian are uncertain of the cyber flag.
          <br /><br />
          If you disagree with Verian&#39;s code and/or cyber flag, please also add a comment as these forms will be referred back to Verian for
          review.
          <br />
          Indicate whether or not you are provisionally coding by selecting from the &#39;provisional&#39; list.
          Provisional coding will need to be confirmed before it is considered final.
          <br />
          When you have finished editing, click the &#39;Save&#39; button.
          <br /><br />
          To view details of the offence, click the &#39;Open Form&#39; button to view the victim form in full.
        </Form.Text>
      );
    case Status.ONSProCoding:
      return (
        <Form.Text>
          Check you are happy with the code and cyber flag you have given each victim form and change any as required.
          <p />
          When you have finished editing, click the &#39;Save&#39; button.
          <br />
          The codes will then be considered confirmed.
          <br />
          To view details of the offence, click the &#39;Open Form&#39; button to view the victim form in full.
        </Form.Text>
      );
    case Status.ONSReview:
      return (
        <Form.Text>
          The ONS and Verian disagree about the code and/or cyber flag for one or more of these victim forms.
          <br />
          For each affected form, please add a comment to further explain your reasoning and respond to any questions Verian has
          noted.
          <p />
          When you have finished editing, click the &#39;Save&#39; button.
          <br />
          The codes will then be considered confirmed.
          <br />
          To view details of the offence, click the &#39;Open Form&#39; button to view the victim form in full.
        </Form.Text>
      );
    default:
      return <></>;
  }
};
